// extracted by mini-css-extract-plugin
export default {"container":"ApplicantDataForm_container__E7qoc","tabs":"ApplicantDataForm_tabs__uovRN","stepError":"ApplicantDataForm_stepError__kK+Lw"};